const axios = require('axios');

export default async function setAsesor(form) {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage._session_token}`
            }
        }
        let data = await axios.post(`${process.env.api}/asesor`, form, config)
        .catch(error => {
            if (error.response.status == 422) {
                return { data: null, error: error.response.data.errors };
            }
        })
        return { data, error: null };
    } catch (error) {
    }
}